import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/portal/organisation/members")({
  beforeLoad: () => {
    throw redirect({ to: "/portal/platform/users" });
  },
});
